import React, { useCallback } from 'react';
import { Box, DownloadIcon, List, PDFIcon, RawButton } from '@common-fe/common-fe';

import { Statement } from './Statements.types';
interface Props extends Statement {
  onOpen?: (id: string) => void;
  onDownload?: (id: string) => void;
}
const StatementsListItem: React.FC<Props> = ({ id, name, onDownload, onOpen }) => {
  const handleOpenPreview = useCallback(() => {
    if (onOpen) {
      onOpen(id);
    }
  }, [id, onOpen]);
  const handleDownloadStatement = useCallback(() => {
    if (onDownload) {
      onDownload(id);
    }
  }, [id, onDownload]);

  return (
    <List.Item testId={`statement_item_${id}`}>
      <Box
        pad="xxs"
        data-testid="statement_pdf-icon"
        round="fieldRound"
        border={{ size: 'small', color: 'border1' }}
      >
        <PDFIcon />
      </Box>
      <List.Item.Link testId={`statement_item_${id}_name`} margin={{ left: 's' }} onClick={handleOpenPreview}>
        {name}
      </List.Item.Link>

      <RawButton data-testId={`statement_item_${id}_download-icon`} onClick={handleDownloadStatement}>
        <DownloadIcon color="iconPrimary" />
      </RawButton>
      <Box margin={{ left: 's' }}>
        <List.Item.Options testId={`statement_item_${id}_options`}>
          <List.Item.Options.Item testId={`statement_item_${id}_view`} onClick={handleOpenPreview}>
            View
          </List.Item.Options.Item>
          <List.Item.Options.Item testId={`statement_item_${id}_download`} onClick={handleDownloadStatement}>
            Download
          </List.Item.Options.Item>
        </List.Item.Options>
      </Box>
    </List.Item>
  );
};

export default StatementsListItem;
